// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "header__text-1Jkpi";
var _4 = "header__payment_cancelled-372RG";
var _5 = "header__payment_problematic-2TXXW";
var _6 = "header-37asg";
var _7 = "header__info-286BW";
var _8 = "header__payment-199t8";
var _9 = "header__image-2BYtH";
var _a = "header__infoItem-11xxV";
var _b = "header__title-3igWg";
var _c = "button__wrapper-3-egK";
var _d = "header__cancel-2rHJB";
var _e = "header__traveller-3rmEt";
var _f = "info__wrapper-3mjzN";
var _10 = "header__textIcon-OFR2h";
var _11 = "header__payment_confirmed-1rSdP";
var _12 = "header__infoButton-34tyQ";
var _13 = "header__details-27qj3";
export { _1 as "__esModule", _2 as "mobile", _3 as "header__text", _4 as "header__payment_cancelled", _5 as "header__payment_problematic", _6 as "header", _7 as "header__info", _8 as "header__payment", _9 as "header__image", _a as "header__infoItem", _b as "header__title", _c as "button__wrapper", _d as "header__cancel", _e as "header__traveller", _f as "info__wrapper", _10 as "header__textIcon", _11 as "header__payment_confirmed", _12 as "header__infoButton", _13 as "header__details" }
export default { "__esModule": _1, "mobile": _2, "header__text": _3, "header__payment_cancelled": _4, "header__payment_problematic": _5, "header": _6, "header__info": _7, "header__payment": _8, "header__image": _9, "header__infoItem": _a, "header__title": _b, "button__wrapper": _c, "header__cancel": _d, "header__traveller": _e, "info__wrapper": _f, "header__textIcon": _10, "header__payment_confirmed": _11, "header__infoButton": _12, "header__details": _13 }
